import { PriceSourceType } from 'types/active'

import { CardType, CategoryType, generateDefaultCategory, OWNED } from 'types/deck'
import { getPrice } from './Price'

export const getDeckPriceAndInfo = (
  deck: CardType[],
  categories: Record<string, CategoryType>,
  priceSource: PriceSourceType = [1],
) => {
  let estDeckCost: number = 0.0
  let costWithoutBasics = 0.0
  let excludingAnyOwned = 0.0
  let excludingExactOwned = 0.0
  let deckSize = 0

  deck.forEach(card => {
    if (!card) return // if the card was removed between renders

    const primaryCategory = categories[card?.categories[0]] || generateDefaultCategory()

    if (primaryCategory.includedInPrice) {
      const { priceNumber } = getPrice(card, priceSource[0], card.modifier !== 'Normal')
      const totalCardPrice = priceNumber * card.qty

      estDeckCost += totalCardPrice

      if (!card.superTypes.includes('Basic')) costWithoutBasics += totalCardPrice
      if (card.owned !== OWNED.YES) excludingExactOwned += totalCardPrice
      if (card.owned === OWNED.NO) excludingAnyOwned += totalCardPrice
    }

    if (primaryCategory.includedInDeck && primaryCategory.name !== 'Sideboard') deckSize += card.qty
  })

  return { estDeckCost, costWithoutBasics, deckSize, excludingAnyOwned, excludingExactOwned }
}
